import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path
      d="M8.54828 6.99996L10.87 4.67826C11.1549 4.39335 11.1549 3.93143 10.87 3.64629L10.354 3.1303C10.0691 2.8454 9.60716 2.8454 9.32203 3.1303L7.00033 5.45201L4.67863 3.1303C4.39372 2.8454 3.93179 2.8454 3.64666 3.1303L3.13067 3.64629C2.84577 3.9312 2.84577 4.39312 3.13067 4.67826L5.45237 6.99996L3.13067 9.32166C2.84577 9.60657 2.84577 10.0685 3.13067 10.3536L3.64666 10.8696C3.93156 11.1545 4.39372 11.1545 4.67863 10.8696L7.00033 8.54791L9.32203 10.8696C9.60693 11.1545 10.0691 11.1545 10.354 10.8696L10.87 10.3536C11.1549 10.0687 11.1549 9.6068 10.87 9.32166L8.54828 6.99996Z"
      fill="black"
    />
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const CloseIcon = memo(ForwardRef);
export default CloseIcon;
